module.exports = __webpack_public_path__ + "static/img/logo.53c859b0.png";